<template>
    <div>

        <div v-if="loadingFrequencia" style="min-height: 350px; display: flex; justify-content: center; align-items: center;">
            <img src="/public/img/loading-bar.gif" />
        </div>
        <div v-else>

            <!--
                Faltas por período, como são lançadas em Diário › Frequência: "Frequência geral"
                (grupo de disciplinas, frequencias.faltas_por_periodo) e as demais disciplinas da
                turma, cada uma com a sua falta (frequencias.faltas_por_disciplina).
            -->
            <table class="table table-striped table-frequencia">
                <thead>
                    <tr>
                        <th class="u-text-left">Disciplina</th>
                        <th v-for="(nome, p) in periodos" :key="'p' + p" class="u-text-center">{{ nome }}</th>
                        <th class="u-text-center">Total</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="linha in linhas" :key="linha.chave">
                        <td class="u-text-left">
                            {{ linha.nome }}
                            <div v-if="linha.detalhe" class="freq-detalhe">{{ linha.detalhe }}</div>
                        </td>
                        <td v-for="(nome, p) in periodos" :key="linha.chave + '-' + p" class="u-text-center">
                            <span :class="{ 'freq-falta': linha.valores[p + 1] > 0 }">
                                {{ linha.valores[p + 1] === null ? '-' : linha.valores[p + 1] }}
                            </span>
                        </td>
                        <td class="u-text-center"><b>{{ linha.algum ? linha.total : '-' }}</b></td>
                    </tr>
                    <tr v-if="!linhas.length">
                        <td :colspan="periodos.length + 2" class="u-text-center">Turma sem disciplinas com frequência.</td>
                    </tr>
                </tbody>
            </table>

            <div class="freq-legenda">
                Faltas lançadas por período em Diário › Frequência. "-" = ainda não lançado; 0 = lançado sem faltas.
            </div>
        </div>
    </div>
</template>
<script>

export default {
    props: ['id', 'turma_id', 'aluno_id', 'tipo_ensino', 'mostra_gerenciar_freq'],
    data: () => ({
        frequencia: {},
        loadingFrequencia: true
    }),
    computed: {
        periodos () {
            return this.frequencia.periodos_nomes || []
        },
        linhas () {
            const linhas = []
            const porDisciplina = this.frequencia.faltas_por_disciplina || {}
            const usadas = {}

            const montar = (chave, nome, detalhe, porPeriodo) => {
                const valores = {}
                let total = 0
                let algum = false
                this.periodos.forEach((n, i) => {
                    const v = porPeriodo ? porPeriodo[i + 1] : undefined
                    const tem = v !== undefined && v !== null && v !== ''
                    valores[i + 1] = tem ? Number(v) : null
                    if (tem) { total += Number(v); algum = true }
                })
                linhas.push({ chave, nome, detalhe, valores, total, algum })
            }

            ;(this.frequencia.opcoes_frequencia || []).forEach(o => {
                if (o.id === 'geral') {
                    montar('geral', o.nome, (o.disciplinas || []).join(', '), this.frequencia.faltas_por_periodo)
                } else {
                    usadas[o.id] = true
                    montar('d' + o.id, o.nome, null, porDisciplina[o.id])
                }
            })

            // Falta lançada em disciplina que saiu do cadastro da turma: continua visível.
            const nomes = this.frequencia.disciplinas_nomes || {}
            Object.keys(porDisciplina).forEach(id => {
                if (!usadas[id]) montar('d' + id, (nomes[id] || ('Disciplina ' + id)), 'não está mais na turma', porDisciplina[id])
            })

            return linhas
        }
    },
    mounted () {
        this.getFrequencia()
    },
    methods: {
        getFrequencia () {

            let payload = {}

            if (this.id) {
                payload['id'] = this.id
            } else {
                payload['contexto'] = null

                if (this.tipo_ensino == 1 || this.tipo_ensino == 2 || this.tipo_ensino == 5) {
                    payload['contexto'] = 'PRINCIPAL'
                } else if (this.tipo_ensino == 3) {
                    payload['contexto'] = 'AEE'
                } else if (this.tipo_ensino == 4) {
                    payload['contexto'] = 'ATIVIDADE_COMPLEMENTAR'
                }

                payload['turma_id'] = this.turma_id
                payload['aluno_id'] = this.aluno_id
            }

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/frequencia/getFrequenciaByFiltros`, payload, this.$store.getters.getHeaderAuth).then(response => {

                if (typeof response.data.error !== 'undefined') {
                    window.eventBus.$emit('alert', { msg: response.data.error, type: 'warning' })
                    this.$emit('close')
                } else {
                    this.frequencia = response.data
                    this.loadingFrequencia = false
                }

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
        }
    }
}
</script>
<style>
    .table-frequencia td, .table-frequencia th {
        border: 1px solid #ccc !important;
    }
    .table-frequencia .freq-falta {
        color: #f56c6c;
        font-weight: bold;
    }
    .table-frequencia .freq-detalhe {
        font-size: 11px;
        color: #909399;
    }
    .freq-legenda {
        font-size: 12px;
        color: #909399;
        margin-top: 6px;
    }
</style>
